import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, careerRequestsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, careerRequestsActions);

export default slice.reducer;
